import { Box } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PhoneInput from "react-phone-input-2";
import ReactCountryFlag from "react-country-flag";
import { PhoneInputWrapper } from "./styles";
import { RawCountry } from "../../../../constants/phoneCode";

interface PhoneNumberInputProps {
  country: RawCountry;
  value: string;
  onChange: (value: string) => void;
  onSelectCountry: () => void;
  placeholder: string;
}

export const PhoneNumberInput = ({
  country,
  value,
  onChange,
  onSelectCountry,
  placeholder,
}: PhoneNumberInputProps) => {
  return (
    <PhoneInputWrapper>
      <Box display="flex" alignItems="center" onClick={onSelectCountry}>
        {country[2] && (
          <ReactCountryFlag
            countryCode={country[2]}
            svg
            className="emojiFlag"
            style={{ width: "1.5rem", height: "1em" }}
          />
        )}
        <KeyboardArrowDownIcon
          fontSize="small"
          sx={{ color: "#777E90", margin: "0 5px" }}
        />
      </Box>

      <PhoneInput
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        country={country[2]?.toLowerCase()}
        autoFormat
        enableLongNumbers={12}
        inputProps={{
          name: "phone",
          required: true,
          autoFocus: true,
        }}
        countryCodeEditable={false}
      />
    </PhoneInputWrapper>
  );
};
